<div class="w-100 d-flex flex-column justify-content-center align-items-start">
  <div *ngIf="!!execution?.observation" class="d-flex align-items-start">
    <ng-container
      [ngTemplateOutlet]="svgTemplate"
      [ngTemplateOutletContext]="{
        type: 'comment-ballon',
        props: {
          class: 'flex-shrink-0 mr-1 mr-md-2 mt-3px'
        }
      }"
    ></ng-container>
    <span class="font-size-4 font-size-md-5 text-bold-500 mr-1 mr-md-2">
      Observações do Treino:
    </span>
    <p class="font-size-4 font-size-md-5">{{ execution.observation }}</p>
  </div>
  <table class="w-100 mt-2 mt-md-3 table-striped">
    <thead>
      <tr>
        <th>
          <span class="font-size-4 font-size-md-5"> Exercício </span>
        </th>
        <th>
          <ng-container
            [ngTemplateOutlet]="svgTemplate"
            [ngTemplateOutletContext]="{
              type: 'comment-ballon',
              props: {
                class: 'flex-shrink-0'
              }
            }"
          ></ng-container>
        </th>
        <th>
          <span class="font-size-4 font-size-md-5"> Carga </span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody
      *ngIf="
        !execution || !execution.exercises || execution.exercises.length === 0
      "
    >
      <tr>
        <td colspan="4">
          <div class="datatable-row-even py-3">
            <span class="font-size-4 font-size-md-5">
              Nenhum exercício com feedback de carga ou observação.
            </span>
          </div>
        </td>
      </tr>
    </tbody>
    <tbody
      *ngIf="execution && execution.exercises && execution.exercises.length > 0"
    >
      <tr *ngFor="let exercise of execution.exercises">
        <td>
          <div
            class="w-100 datatable-row-even position-relative reduced-text-container"
          >
            <div class="d-flex position-absolute">
              <ng-container
                [ngTemplateOutlet]="spanTemplate"
                [ngTemplateOutletContext]="{
                  text: exercise.name,
                  props: {
                    ngbTooltip: exercise.name,
                    placement: 'right'
                  }
                }"
              ></ng-container>
            </div>
          </div>
        </td>
        <td>
          <div
            class="w-100 datatable-row-even position-relative reduced-text-container"
          >
            <div class="d-flex position-absolute">
              <span class="font-size-4 font-size-md-5">
                <ng-container
                  [ngTemplateOutlet]="spanTemplate"
                  [ngTemplateOutletContext]="{
                    text:
                      exercise.exerciseObservation !== null
                        ? exercise.exerciseObservation
                        : '-',
                    props: {
                      ngbTooltip:
                        exercise.exerciseObservation !== null
                          ? exercise.exerciseObservation
                          : '-'
                    }
                  }"
                ></ng-container>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="w-100 datatable-row-even justify-content-start">
            <span class="font-size-4 font-size-md-5 mr-2">
              {{
                exercise.loadFeedback !== null
                  ? exercise.loadFeedback + "kg"
                  : exercise.loadFeedbackSt !== null ? exercise.loadFeedbackSt : "-"
              }}
            </span>
            <ng-container
              *ngIf="hasExerciseLoadEvolution(exercise)"
              [ngTemplateOutlet]="svgTemplate"
              [ngTemplateOutletContext]="{
                type: 'arrow-up',
                props: {
                  placement: 'top',
                  ngbTooltip: 'Houve Evolução de Carga.',
                  container: 'body',
                  class:
                    'flex-shrink-0' +
                    (hasExerciseLoadEvolution(execution) ? ' ml-1 ml-md-2' : '')
                }
              }"
            ></ng-container>
          </div>
        </td>
        <td>
          <button
            type="button"
            [disabled]="
              !hasExerciseLoadVariation(exercise.id) || ($sLoading | async)
            "
            (click)="openLoadEvolutionModal(execution, exercise.id)"
            class="btn btn-sm shadow-none p-0"
            [ngClass]="
              hasExerciseLoadVariation(exercise.id) && !($sLoading | async)
                ? 'text-primary'
                : 'text-muted'
            "
          >
            <i class="ft-trending-up font-size-6 font-size-md-7"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- ! responsive text -->
<ng-template #spanTemplate let-text="text" let-props="props">
  <span
    [placement]="props.placement ? props.placement : 'top'"
    [ngbTooltip]="props.ngbTooltip"
    container="body"
    [triggers]="clientDevice === 'mobile' ? 'click:blur' : 'hover focus'"
    class="font-size-4 font-size-md-5"
    [ngClass]="props.class"
  >
    {{ text }}
  </span>
</ng-template>

<!-- ! SVGS -->
<ng-template #svgTemplate let-type="type" let-props="props">
  <svg
    *ngIf="type === 'comment-ballon'"
    id="comment-ballon"
    width="16"
    height="16"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [placement]="props.placement"
    [ngbTooltip]="props.ngbTooltip"
    [container]="props.container"
    [triggers]="clientDevice === 'mobile' ? 'click:blur' : 'hover focus'"
    [ngClass]="props.class"
  >
    <path
      d="M2.5207 3.15508C2.27927 3.15508 2.08355 3.3508 2.08355 3.59223C2.08355 3.83366 2.27927 4.02938 2.5207 4.02938V3.15508ZM6.60077 4.02938C6.8422 4.02938 7.03792 3.83366 7.03792 3.59223C7.03792 3.3508 6.8422 3.15508 6.60077 3.15508V4.02938ZM3.03071 4.64663C2.78928 4.64663 2.59356 4.84236 2.59356 5.08378C2.59356 5.32521 2.78928 5.52093 3.03071 5.52093V4.64663ZM6.09076 5.52093C6.33219 5.52093 6.52791 5.32521 6.52791 5.08378C6.52791 4.84236 6.33219 4.64663 6.09076 4.64663V5.52093ZM2.61571 1.10513V0.667969L2.61252 0.667992L2.61571 1.10513ZM6.50635 1.10513L6.50967 0.66798H6.50635V1.10513ZM8.64081 3.27165L8.20366 3.26844V3.27165H8.64081ZM8.64081 5.90213H8.20366V5.90533L8.64081 5.90213ZM6.50576 8.06865V8.5058H6.50897L6.50576 8.06865ZM2.61571 8.06865V7.6315C2.54086 7.6315 2.46727 7.65073 2.40198 7.68734L2.61571 8.06865ZM0.480666 9.26527H0.0435153C0.0435153 9.42043 0.125787 9.56399 0.259683 9.64245C0.393573 9.7209 0.559026 9.72247 0.694397 9.64658L0.480666 9.26527ZM0.480666 3.27165H0.917828L0.917804 3.26844L0.480666 3.27165ZM2.5207 4.02938H6.60077V3.15508H2.5207V4.02938ZM3.03071 5.52093H6.09076V4.64663H3.03071V5.52093ZM2.61571 1.54228H6.50635V0.66798L2.61571 0.667969V1.54228ZM6.50303 1.54227C7.44931 1.54942 8.21059 2.32219 8.20366 3.26844L9.07796 3.27486C9.08845 1.84584 7.93869 0.678787 6.50967 0.66798L6.50303 1.54227ZM8.20366 3.27165V5.90213H9.07796V3.27165H8.20366ZM8.20366 5.90533C8.20698 6.35985 8.02967 6.797 7.71061 7.12073L8.33335 7.73443C8.81514 7.24552 9.08297 6.58531 9.07796 5.89892L8.20366 5.90533ZM7.71061 7.12073C7.39161 7.44445 6.95708 7.62817 6.50256 7.6315L6.50897 8.5058C7.1953 8.50078 7.85161 8.22334 8.33335 7.73443L7.71061 7.12073ZM6.50576 7.6315H2.61571V8.5058H6.50576V7.6315ZM2.40198 7.68734L0.266934 8.88396L0.694397 9.64658L2.82944 8.44996L2.40198 7.68734ZM0.917816 9.26527L0.917828 3.27165H0.0435153V9.26527H0.917816ZM0.917804 3.26844C0.914465 2.81395 1.09181 2.37675 1.41083 2.05303L0.788105 1.43935C0.306319 1.92823 0.0384851 2.58849 0.0435269 3.27486L0.917804 3.26844ZM1.41083 2.05303C1.72986 1.72931 2.16441 1.54558 2.6189 1.54227L2.61252 0.667992C1.92615 0.672993 1.26989 0.950461 0.788105 1.43935L1.41083 2.05303Z"
      fill="currentColor"
    />
  </svg>
  <svg
    *ngIf="type === 'arrow-up'"
    id="arrow-up"
    width="16"
    height="16"
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [placement]="props.placement"
    [ngbTooltip]="props.ngbTooltip"
    [container]="props.container"
    [triggers]="clientDevice === 'mobile' ? 'click:blur' : 'hover focus'"
    [ngClass]="props.class"
  >
    <path
      d="M3.51917 1.09082V9.41699M3.51917 1.09082L0.71875 4.05273M3.51917 1.09082L6.33478 4.05273"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>
